import { FC } from 'react';
import ChevronLeft from 'src/assets/icons/ChevronLeft';
import ChevronRight from 'src/assets/icons/ChevronRight';

interface DocumentTrackerProps {
  current: number;
  total: number;
  increment: VoidFunction;
  decrement: VoidFunction;
}

const DocumentTracker: FC<DocumentTrackerProps> = ({ current, total, increment, decrement }) => (
  <div className="flex flex-row items-center p-2 gap-2 justify-center">
    <button
      onClick={decrement}
      disabled={current === 1}
      className="bg-dark rounded-full text-light p-1 disabled:bg-gray-400 disabled:cursor-not-allowed"
    >
      <ChevronLeft />
    </button>
    <div>
      Document {current} of {total}
    </div>
    <button
      onClick={increment}
      disabled={current === total}
      className="bg-dark rounded-full text-light p-1 disabled:bg-gray-400 disabled:cursor-not-allowed"
    >
      <ChevronRight />
    </button>
  </div>
);

export default DocumentTracker;
